export const decodeUuidFromBase64 = (base64) => {
  try {
    // Validate input
    if (!base64 || typeof base64 !== 'string') {
      return null;
    }

    // Convert Base64 URL-safe to standard Base64
    let base64Standard = base64.replace(/-/g, '+').replace(/_/g, '/');

    // Add necessary padding
    while (base64Standard.length % 4) {
      base64Standard += '=';
    }

    // Validate base64 format before decoding
    const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
    if (!base64Regex.test(base64Standard)) {
      return null;
    }

    // Decode Base64 into a Uint8Array
    const binary = atob(base64Standard);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i);
    }

    // Convert bytes to UUID format
    const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');

    // Validate UUID length (should be 32 hex characters for a UUID)
    if (hex.length !== 32) {
      return null;
    }

    return `${hex.substring(0, 8)}-${hex.substring(8, 12)}-${hex.substring(12, 16)}-${hex.substring(16, 20)}-${hex.substring(20)}`;
  } catch (error) {
    return null;
  }
};
